import { render, staticRenderFns, recyclableRender, components } from "./verify-store-info.vue?vue&type=template&id=5b53ef14&scoped=true&"
var renderjs
import script from "./verify-store-info.vue?vue&type=script&lang=js&"
export * from "./verify-store-info.vue?vue&type=script&lang=js&"
import style0 from "./verify-store-info.vue?vue&type=style&index=0&id=5b53ef14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53ef14",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/confirm-order/verify-store-info.vue"
export default component.exports